import { useEffect, useRef, useState } from 'react';
import { containerState, facingMode } from '../../constant';

import styles from './confirm.less';
import { ChatBodyEndButton, ChatBodyEndButtonVideo } from './styled';

import customerIcon from '../../assets/video1.svg';
import microphoneIconBright from '../../assets/video2.svg';
import cameraIconDark from '../../assets/video3.svg';
import callEndIcon from '../../assets/video4.svg';
import cameraIconBright from '../../assets/video5.svg';
import microphoneIconDark from '../../assets/video6.svg';
import callPageBgImage from '../../assets/videoBg2.svg';
import VideoOverturn from '../../assets/videoOverturn.png';
import VideoOverturning from '../../assets/videoOverturning.png';

import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';
import { requestOpenVideo } from '../../utils/api';

// 终极方法
const useGetState = (initVal) => {
  const [state, setState] = useState(initVal);
  const ref = useRef(initVal);
  const setStateCopy = (newVal) => {
    ref.current = newVal;
    setState(newVal);
  };
  const getState = () => ref.current;
  return [state, setStateCopy, getState];
};

const confirmVideo = (props) => {
  // 组件传递过来的数据和函数
  const {
    device,
    chatConfig,
    initiateChatRequest,
    setContactId,
    handleOpenVideo,
    handleEndChatSession,
    setEvaluationState,
    handleEndVideo,
  } = props;

  // 通话状态、0等待确认发起，1正在连接、2连接完成、3连接结束、4取消连接
  const [connectState, setConnectState, getConnectState] = useGetState(0);
  // 是否开启视频功能状态
  const [openVideoState, setOpenVideoState] = useState(false);
  // 设备-麦克风开关状态
  const [microphoneState, setMicrophoneState] = useState(false);
  // 设备-摄像头开关状态
  const [cameraState, setCameraState] = useState(false);
  // 设备-摄像头反转状态
  const [cameraReversalState, setCameraReversalState] = useState(false);
  // 坐席视频窗口dom数据
  const agentVideoRef = useRef(null);
  // 本地视频窗口dom数据
  const localVideoRef = useRef(null);
  // 当前通话会议数据
  const meetingManager = useMeetingManager();
  // 当前通话会议事件对象
  const [observer, setObserver, getObserver] = useGetState(null);
  // 视频输入设备-前置
  const [frontCameraDevice, setFrontCameraDevice] = useState(null);
  // 视频输入设备-后置
  const [backCameraDevice, setBackCameraDevice] = useState(null);

  const [videoInputDevicesJson, setVideoInputDevicesJson] = useState('');

  // 当前使用的相机流，用于关闭相机
  const [currentVideoStream, setCurrentVideoStream] = useState(null);

  useEffect(async () => {
    // console.log('进入视频页面', connectState);
    // console.log("Chat - 是否是只拨打视频通话的", chatConfig.isVideoContainer);
    // console.log("Chat - 是否允许开启摄像头", chatConfig.openVideo === '1');

    // 判断是否执行加载客户端
    if (chatConfig.isVideoContainer) {
      await handleClickConfirm();
    }

    return () => {
      setConnectState(0);
      setOpenVideoState(false);
      setMicrophoneState(false);
      setCameraState(false);
      setCameraReversalState(false);
      setObserver(null);
      setFrontCameraDevice(null);
      setCurrentVideoStream(null);
    };
  }, []);

  // 处理点击取消按钮
  const handleClickCancel = () => {
    handleOpenVideo(containerState.CHAT_WIDGET);
  };

  // 处理点击确认按钮
  const handleClickConfirm = async () => {
    handleEndChatSession(); // 断开chat聊天
    setConnectState(1); // 设置通话状态为正在连接
    await initCallConfig(); // 执行初始化通话配置信息
    // console.log('isVideoEnd');
    window.forNativeVideoStatus = true;
  };

  // 加载video通话客户端=========================================================================================================

  // 初始化通话配置
  const initCallConfig = async () => {
    let response = null;
    try {
      // 从服务器应用程序获取会议和与会者数据
      response = await requestOpenVideo(initiateChatRequest, chatConfig.videoApiGateway);
      setContactId(response.ContactId); // 设置联系id，表示以接通人工
    } catch (e) {}

    if (response) {
      // 创建会议会话配置
      const meetingSessionConfiguration = new MeetingSessionConfiguration(
        response.ConnectionData.Meeting,
        response.ConnectionData.Attendee
      );
      await meetingManager.join(meetingSessionConfiguration); // 使用join API使用DeviceLabels.Video创建会议会话

      // 设置麦克风图标状态为开启
      setMicrophoneState(true);

      // 判断配置中是否允许开启摄像头
      if (chatConfig.openVideo === '1') {
        await listCameras();
      }

      // 监听摄像头和音频的事件
      setupMeetingObserver();

      // 开始会话加入会议
      await meetingManager.start();
    }
  };

  // 设置视频通话的音视频监听器
  const setupMeetingObserver = () => {
    let agentTileId = 0;
    let localTileId = 0;
    const observer = {
      // 音视频通话开始
      audioVideoDidStart: (event) => {
        // 如果状态为“取消连接”，执行结束通话
        if (getConnectState() === 4) {
          meetingManager?.leave(); // 挂断通话
          return;
        }
        setConnectState(2);
      },
      // 音视频通话结束
      audioVideoDidStop: (event) => {
        // 关闭音频设备
        meetingManager.audioVideo?.stopAudioInput(); // 音频

        // 如果开启了视频
        if (openVideoState) {
          try {
            // 关闭音频设备
            meetingManager.audioVideo?.stopLocalVideoTile();
            meetingManager.audioVideo?.stopVideoInput();
          } catch (e) {}
        }

        setConnectState(3);

        meetingManager.audioVideo?.removeObserver(getObserver());

        // handleOpenVideo(containerState.CHAT_WIDGET); // 切回到聊天页面
        backChatPage();
      },
      // 视频流发生变化
      videoTileDidUpdate: (event) => {
        // 如果是坐席方摄像头发生变化
        if (event.boundAttendeeId && !event.localTile) {
          setConnectState(2);
          if (meetingManager.audioVideo) {
            meetingManager.audioVideo.bindVideoElement(event.tileId, agentVideoRef.current);
            agentTileId = event.tileId;
            // 坐席方开启了摄像头隐藏客服图标
            document.getElementById('videoTipsImg').style.display = 'none';
          }
          return;
        }

        // 如果是客户方摄像头发生变化
        if (!event.boundAttendeeId && event.localTile) {
          if (meetingManager.audioVideo) {
            meetingManager.audioVideo.bindVideoElement(event.tileId, localVideoRef.current);
            localTileId = event.tileId;
          }
        }
      },
      // 摄像头视图移除
      videoTileWasRemoved: (event) => {
        // 如果是坐席方关闭了摄像头，则显示客服图标
        if (agentTileId === event && localTileId !== event) {
          document.getElementById('videoTipsImg').style.display = 'block';
        }
      },
    };
    setObserver(observer);
    meetingManager.audioVideo.addObserver(observer);
  };

  // =========================================================================================================

  // 获取摄像头设备
  const listCameras = async () => {
    let hasVideoInput = false;

    if (device === 'pc') {
      const meetingDevices = await meetingManager.audioVideo.listVideoInputDevices();
      const deviceInfo = meetingDevices?.find((d) => d.kind === 'videoinput');
      setFrontCameraDevice(deviceInfo); // 设置摄像头设备 - 用于PC端开启相机使用
      hasVideoInput = !!deviceInfo;
    } else if (device === 'mobile') {
      const devices = await navigator.mediaDevices.enumerateDevices();
      hasVideoInput = devices.some((d) => d.kind === 'videoinput');
    }

    setOpenVideoState(hasVideoInput); // 设置是否开启相机状态
  };

  // 返回聊天页面
  const backChatPage = () => {
    setEvaluationState(true); // 满意度评分
    handleEndVideo(); // 通知父页面通话结束
    handleOpenVideo(containerState.CHAT_WIDGET); // 切回到聊天页面
    console.log('isVideoEnd');
    window.forNativeVideoStatus = false;
  };

  // 处理点击挂断按钮 type：1连接中挂断，2通话中挂断
  const handleClickCallEnd = async (type) => {
    if (type === 1) {
      setConnectState(4);
      return;
    }

    if (type === 2) {
      await meetingManager?.leave(); // 调用挂断方法
    }
  };

  // 处理点击麦克风开关图标
  const handleClickMicrophone = () => {
    let value = !microphoneState;
    setMicrophoneState(value);
    if (value) {
      meetingManager.audioVideo.realtimeUnmuteLocalAudio();
    } else {
      meetingManager.audioVideo.realtimeMuteLocalAudio();
    }
  };

  // 摄像头相关 start===================================================================================================

  // 处理点击摄像头开关图标
  const handleClickCamera = async () => {
    if (connectState === 2) {
      const value = !cameraState;
      setCameraState(value);

      if (value) {
        // 开启摄像头
        device === 'mobile' ? await setMobileCameraDevice(false) : await startVideoInput();
      } else {
        // 关闭摄像头
        if (device === 'mobile' && currentVideoStream) {
          currentVideoStream.getTracks().forEach((track) => track.stop());
        }
        await stopVideoInput();
      }
    }
  };

  // 开启相机 - PC端使用到了
  async function startVideoInput() {
    await meetingManager.audioVideo.startVideoInput(frontCameraDevice.deviceId);
    meetingManager.audioVideo.startLocalVideoTile();
  }

  // 关闭相机 - pc和移动端都使用到了
  async function stopVideoInput() {
    meetingManager.audioVideo.stopLocalVideoTile();
    await meetingManager.audioVideo.stopVideoInput();
  }

  // 获取相机并设置使用它 - 移动端使用
  const setMobileCameraDevice = async (state) => {
    console.log('LiveChat - 摄像头状态', state);

    // 先关闭当前使用相机流
    if (currentVideoStream) {
      await currentVideoStream.getTracks().forEach((i) => i.stop());
    }

    let devicesJson = {
      deviceList: [],
      mediaDeviceList: [],
    };

    // 获取移动端相机设备列表
    const devices = await navigator.mediaDevices.enumerateDevices();
    devices.forEach((device) => {
      if (device.kind === 'videoinput') {
        console.log('LiveChat - Camera found:', device.label, device.deviceId);
        devicesJson.deviceList.push(device);
      }
    });

    // 相机镜头类型
    const facingModeStr = state ? facingMode.ENVIRONMENT : facingMode.USER;
    // 获取相机设备
    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: facingModeStr } } }).then(async (stream) => {
      // 保存当前相机流
      setCurrentVideoStream(stream);
      console.log('LiveChat - stream.getVideoTracks()', stream.getVideoTracks().length, stream.getVideoTracks());
      for (const track of stream.getVideoTracks()) {
        const index = stream.getVideoTracks().indexOf(track);
        let deviceInfo = track.getSettings();
        console.log('LiveChat - deviceInfo', deviceInfo);

        devicesJson.mediaDeviceList.push(deviceInfo);
        setVideoInputDevicesJson(JSON.stringify(devicesJson));

        if (index === 0) {
          // 开启相机
          await meetingManager.audioVideo.startVideoInput(deviceInfo.deviceId);
          meetingManager.audioVideo.startLocalVideoTile();
        }
      }
    });
  };

  // 处理点击摄像头反转图标 - 移动端使用
  const handleClickCameraReversal = async () => {
    if (cameraState) {
      const newCameraReversalState = !cameraReversalState;
      setCameraReversalState(newCameraReversalState);
      // 设置当前相机设备
      await setMobileCameraDevice(newCameraReversalState);
    }
  };

  // 摄像头相关 end===================================================================================================

  const handleClickCopy = (e) => {
    const textArea = document.createElement('textarea');
    textArea.value = e;
    // 添加到文档中
    textArea.style.position = 'fixed';
    textArea.style.left = '0';
    textArea.style.top = '0';
    document.body.appendChild(textArea);
    textArea.select(); // 选择文本
    try {
      document.execCommand('copy');
    } catch (err) {}
    textArea.remove(); // 移除元素
  };

  return (
    <div className={styles.videoPage}>
      {/*<div style={{position: 'absolute', zIndex: 99999999999}}>
        <div
          style={{
            width: '150px',
            height: '140px',
            overflow: 'auto',
            background: '#000',
            color: '#fff',
            fontSize: '12px',
          }}
        >
          相机JSON：
          {videoInputDevicesJson}
        </div>
        <div
          onClick={() => handleClickCopy(videoInputDevicesJson)}
          style={{
            cursor: 'pointer',
            textAlign: 'center',
            background: 'red',
            padding: '10px 10px',
            fontSize: '12px',
            color: '#000',
          }}
        >
          复制
        </div>

        <div
          onClick={() => handleStartRecording()}
          style={{
            cursor: 'pointer',
            textAlign: 'center',
            background: '#f5d1e1',
            padding: '10px 10px',
            fontSize: '12px',
            color: '#000',
          }}
        >
          开始录音哈
        </div>
        <div
          onClick={() => handleStopRecording()}
          style={{
            cursor: 'pointer',
            textAlign: 'center',
            background: '#b5cbde',
            padding: '10px 10px',
            fontSize: '12px',
            color: '#000',
          }}
        >
          结束录音哈
        </div>
      </div>*/}

      {/* 没点确认的提示页面 */}
      {connectState === 0 && (
        <div className={styles.main}>
          <div style={{ textAlign: 'center' }}>
            <img src={customerIcon} style={{ width: 80, height: 80 }} alt="" />
            <div style={{ textAlign: 'center' }}></div>
            <div className={styles.fontBox} style={{ marginTop: device === 'mobile' ? '8.5vw' : '2.5vw' }}>
              <span className={styles.fontBig} style={{ fontSize: device === 'mobile' ? '5vw' : '1.13rem' }}>
                {chatConfig.videoTips}
              </span>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 50,
            }}
          >
            <ChatBodyEndButton onClick={() => handleClickCancel()} device={device}>
              {chatConfig.videoTipsCancel}
            </ChatBodyEndButton>
            <ChatBodyEndButtonVideo
              onClick={() => handleClickConfirm()}
              device={device}
              $themecolor={chatConfig.chatThemeColor}
            >
              {chatConfig.videoTipsAccept}
            </ChatBodyEndButtonVideo>
          </div>
        </div>
      )}

      {/* 未链接上connect */}
      {connectState === 1 && (
        <div className={styles.mainPadding}>
          <div className={styles.box} style={{ marginTop: '-4rem' }}>
            <img src={customerIcon} alt="" />
            <span className={styles.font} style={{ fontSize: '1rem' }}>
              {chatConfig.videoConnecting}
            </span>
          </div>
          <div className={styles.boxMiddle} style={{ marginTop: '-8rem' }}></div>
          <div
            onClick={() => handleClickCallEnd(1)}
            className={`${styles.box} ${styles.handle}`}
            style={{ marginTop: '-5rem' }}
          >
            <img src={callEndIcon} alt="" />
            <span className={styles.font} style={{ fontSize: '1rem' }}>
              {chatConfig.videoEnd}
            </span>
          </div>
        </div>
      )}

      {/* 已链接上connect */}
      {connectState === 2 && (
        <div id="mainVideo" className={styles.mainVideo} style={{ backgroundImage: `url(${callPageBgImage})` }}>
          <video ref={agentVideoRef} autoPlay playsInline style={{ zIndex: '2' }} />

          <div
            className={`${styles.box} ${styles.handle}`}
            style={{
              marginTop: device === 'mobile' ? '-25rem' : '-17rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img id="videoTipsImg" src={chatConfig.chatFormIcon} style={{ height: 90 }} alt="" />
          </div>

          <video
            id="localVideo"
            ref={localVideoRef}
            autoPlay
            playsInline
            style={{
              height: device === 'mobile' ? '40vw' : '30%',
              width: device === 'mobile' ? '60vw' : '50%',
              borderRadius: 10,
              position: 'absolute',
              top: device === 'mobile' ? '5vh' : '20px',
              right: device === 'mobile' ? '4vw' : '10px',
            }}
          />

          <div className={styles.boxFoot}>
            {/*麦克风开关*/}
            <div className={`${styles.box} ${styles.handle}`} onClick={() => handleClickMicrophone()}>
              {microphoneState ? <img src={microphoneIconBright} alt="" /> : <img src={microphoneIconDark} alt="" />}
              {microphoneState ? (
                <span className={styles.font}>{chatConfig.mute}</span>
              ) : (
                <span className={styles.font}>{chatConfig.unmute}</span>
              )}
            </div>

            {/*摄像头开关*/}
            {openVideoState && (
              <div className={`${styles.box} ${styles.handle}`} onClick={() => handleClickCamera()}>
                {cameraState ? <img src={cameraIconBright} alt="" /> : <img src={cameraIconDark} alt="" />}
                {cameraState ? (
                  <span className={styles.font}>{chatConfig.stopVideo}</span>
                ) : (
                  <span className={styles.font}>{chatConfig.startVideo}</span>
                )}
              </div>
            )}

            {/*摄像头反转状态*/}
            {openVideoState && device === 'mobile' && (
              <div className={`${styles.box} ${styles.handle}`} onClick={() => handleClickCameraReversal()}>
                <img src={cameraReversalState ? VideoOverturning : VideoOverturn} alt="" />
                <span className={styles.font}>{chatConfig.videoOverturn}</span>
              </div>
            )}

            {/*挂断按钮*/}
            <div className={`${styles.box} ${styles.handle}`} onClick={() => handleClickCallEnd(2)}>
              <img src={callEndIcon} alt="" />
              <span className={styles.font}>{chatConfig.videoEnd}</span>
            </div>
          </div>
        </div>
      )}

      {/* 取消connect连接/结束通话 */}
      {(connectState === 3 || connectState === 4) && (
        <div className={styles.mainPadding}>
          <div className={styles.box} style={{ marginTop: '-4rem' }}>
            <img src={customerIcon} alt="" />
            <span className={styles.font} style={{ fontSize: device === 'mobile' ? '5vw' : '' }}>
              {connectState === 3 ? '通话结束' : connectState === 4 ? '取消连接' : '-'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default confirmVideo;
